module.exports = __webpack_public_path__ + "img/cardbackground.4597a8f3.jpg";